import { apiSlice } from '../../api/apiSlice';

export const messageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMessageGroup: builder.mutation({
      query: () => ({
        url: 'MessageGroup/GetAll',
        method: 'GET',
        credentials: 'include'
      })
    }),
    messageGroupNameUpdate: builder.mutation({
      query: ({ id, name }) => ({
        url: `MessageGroup/${id}/Rename?name=${name}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    messageGroupDelete: builder.mutation({
      query: (messageGroupId) => ({
        url: `MessageGroup/${messageGroupId}/Delete`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    messageGroupCreate: builder.mutation({
      query: (option) => ({
        url: `MessageGroup/create?name=${option.name}`,
        method: 'POST',
        credentials: 'include',
        body: option.studentIds
      })
    }),
    getMessageGroupMembers: builder.mutation({
      query: (messageGroupId) => ({
        url: `MessageGroup/${messageGroupId}/Members`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    addingGroupMembers: builder.mutation({
      query: (options) => ({
        url: `MessageGroup/${options.messageGroupId}/Members/${options.userIds}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    removingGroupMembers: builder.mutation({
      query: (options) => ({
        url: `MessageGroup/${options.messageGroupId}/Members/${options.userIds}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    sendMessage: builder.mutation({
      query: (options) => ({
        url: 'Alert/SendMessage',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    messageDelete: builder.mutation({
      query: (id) => ({
        url: `Alert/Delete?alertId=${id}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    messageBulkDelete: builder.mutation({
      query: (ids) => ({
        url: 'Alert/BulkDelete',
        method: 'DELETE',
        credentials: 'include',
        body: ids
      })
    }),
    messageDetails: builder.mutation({
      query: (alertId) => ({
        url: `Alert/${alertId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    messageViewStatus: builder.mutation({
      query: (alertId) => ({
        url: `Alert/${alertId}/ViewStatus`,
        method: 'PUT',
        credentials: 'include'
      })
    })
  })
});

export const {
  useGetMessageGroupMutation,
  useMessageGroupNameUpdateMutation,
  useMessageGroupDeleteMutation,
  useMessageGroupCreateMutation,
  useGetMessageGroupMembersMutation,
  useAddingGroupMembersMutation,
  useRemovingGroupMembersMutation,
  useSendMessageMutation,
  useMessageDeleteMutation,
  useMessageBulkDeleteMutation,
  useMessageDetailsMutation,
  useMessageViewStatusMutation
} = messageApi;
